<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'

	const { title, subtitle } = defineProps<{
		title?: string
		titleCls?: ClassNameValue
		subtitle?: string
		subtitleCls?: ClassNameValue
	}>()
</script>
<template>
	<header class="space-y-[8px]">
		<h2
			:class="
				cn(
					'text-pretty text-[22px] font-bold leading-[140%] text-gray-900 md:text-2xl md:text-[34px]',
					titleCls
				)
			"
		>
			<slot name="title">
				<span v-html="title" />
			</slot>
		</h2>
		<p
			:class="
				cn(
					'w-full max-w-[580px] text-xs font-medium leading-[140%] text-gray-600 sm:text-sm md:text-base',
					subtitleCls
				)
			"
			v-html="subtitle"
		/>
	</header>
</template>
